//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AttributeOrigin",1,0],[0,"ConnectedToInformation",1,0],[1,"FabricationObjects",0,"SelectNXObjectList",0],[0,"OutputAttributes",1,0],[0,"OutputLengthAndVolume",1,0]],[[[],"GetTotalLength",{R_:{totalLength:''}},0,0],[[],"GetTotalVolume",{R_:{totalVolume:''}},0,0]],[]];
SPLM.Weld.InformationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.InformationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.InformationBuilder.AttributeOriginType = Object.freeze({
    "Object" : "Object", "Df" : "Df"});

export default SPLM;